module.exports = "/images/vendor/desiigner-svg/svg/places/sandals.svg?72ab8a1687a9c25449b8c59c8601b9b0";